import { QUESTIONNAIRE, QUESTIONNAIRE_CANCEL } from "./types";
import { generateLog } from "./utils";

export const EXAM_TYPE = "exam";
export const REG_TYPE = "reg";

export const generateQuestionnaireLog = (data, userId) =>
	generateLog(data, QUESTIONNAIRE, userId);
export const generateQuestionnaireCancelLog = (data, userId) =>
	generateLog(data, QUESTIONNAIRE_CANCEL, userId);
